module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/hydrangea-left-icon-1b9d8b149477e99e845ce334c590f61c.svg";